module.exports = "d1b9712228324f73a1d94b7f300459aa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/done.png
// module id = 69
// module chunks = 0